import { sm } from "src/styles/utility";

export function openWindow(url: string) {
  const small = window.matchMedia(`(${sm})`);

  if (small.matches) {
    window.location.href = url;
  } else {
    const newWindow = window.open(url);

    if (
      !newWindow ||
      newWindow.closed ||
      typeof newWindow.closed === "undefined"
    ) {
      window.location.href = url;
    }
  }
}
